// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import comp from './components/index';
import api from './api/home-api';
import './assets/icon/iconfont.css'


import {detectZoom} from "./utils/detectZoom";
let isPc = detectZoom();
let screenWidth = document.documentElement.clientWidth;
window.addEventListener("resize", ()=>{
  if (screenWidth !== document.documentElement.clientWidth) {
    isPc = detectZoom();
    app.$router.push(isPc ? { name: "home" } : { name: "mhome" }).catch(() => {});
  }
});


Vue.config.productionTip = false
comp.install(Vue);



/* eslint-disable no-new */
let app = new Vue({
  el: '#app',
  router: router,
  components: { App },
  created(){
    window.api = api;
  },
  template: '<App/>'
})
if (app.$route.name !== "yhxy" && app.$route.name !== "ysxy") {
  app.$router.push(isPc ? { name: "home" } : { name: "mhome" }).catch(() => {});
}
// app.$router.push({ name: "ysxy" }).catch(() => {});



// WEBPACK FOOTER //
// ./src/main.js